'use client';

import React, { useEffect } from 'react';

import { LoadingBall } from '@depop/web-ui-kit/LoadingBall';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { SitemapTopCategory } from '@/app/[locale]/site-map/categories/components/SitemapTopCategory';
import { ErrorMessage } from '@/components/ErrorMessage';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useGroupsById } from '@/modules/categories/useGroupsById';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

function CategoriesSitemap() {
  const tCommon = useTranslations('common');
  const [, currentUser] = useCurrentUser();
  const userId = currentUser?.id;
  const { sendActivityTrackerEvent } = useActivityTracker({ userId });

  useEffect(() => {
    sendActivityTrackerEvent(ActivityTrackerEventType.BROWSE_BY_VIEW, {
      type: 'sitemap',
    });
  }, []);

  const {
    data: categoriesByGroupData,
    isLoading: isLoadingCategoriesByGroups,
    isError: isCategoriesByGroupsError,
  } = useGroupsById();

  if (isLoadingCategoriesByGroups) {
    return <LoadingBall />;
  }

  if (isCategoriesByGroupsError) {
    return <ErrorMessage type="body">{tCommon('500.Message')}</ErrorMessage>;
  }

  if (!categoriesByGroupData) {
    return <ErrorMessage type="body">{tCommon('NoResults')}</ErrorMessage>;
  }

  const allDepartments = new Set<string>();
  Object.values(categoriesByGroupData.data).forEach((group) => {
    group.department.forEach((dept) => allDepartments.add(dept));
  });

  const groupsByDepartment = Array.from(allDepartments).map((department) => {
    const relevantGroups = Object.values(categoriesByGroupData.data).filter(
      (group) => group.department.includes(department)
    );
    return { department, groups: relevantGroups };
  });

  return (
    <ul className={styles.list}>
      {groupsByDepartment.map(({ department, groups }) => (
        <SitemapTopCategory
          key={department}
          department={department}
          groups={groups}
        />
      ))}
    </ul>
  );
}

export { CategoriesSitemap };
